
import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { DischargeCodeDetailBO, functionpermission, sortingObj, WhereCondition, GetListBO, columnWidth, ColumnChangeBO } from './discharge-codes.model';
import { GlobalComponent } from "../../global/global.component";
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/service/general.service';
import { FilterSettingsModel, IFilter, GridComponent, PageSettingsModel, DataStateChangeEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { Observable } from 'rxjs';
import { ChangeEventArgs } from '@syncfusion/ej2-angular-inputs';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonApiService } from 'src/app/commonapiservice';
declare var $: any;
@Component({
  selector: 'app-discharge-codes',
  templateUrl: './discharge-codes.component.html',
  styleUrls: ['./discharge-codes.component.scss'],
})
export class DischargeCodesComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('grid') public grid: GridComponent;
  @Input() changevalue: string;
  viewClient: boolean = false;
  @Output() dataFromDC = new EventEmitter<{ code: number, description: string }>();
  DischargeArray: DischargeCodeDetailBO[];
  dccodes: DischargeCodeDetailBO = new DischargeCodeDetailBO();
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  DischargeForm: FormGroup;
  filterItems: { [key: string]: string } = {
    'DischargeCode': 'DischargeCode',
  };
  SearchText: string = '';
  SearchColumn: { [key: string]: string } = { 'DischargeCode': 'DischargeCode' };
  DischargeDataList: any = [];
  updateCLi: boolean;
  isCreate: boolean = false;
  pagshort: sortingObj = new sortingObj();
  isUpdate: boolean = false;
  DCForm: FormGroup;
  close: boolean;
  filterOptions: FilterSettingsModel;
  columnsSelected: string[] = ['DischargeCode'];
  columnsList: string[] = ['DischargeCode'];
  ModelType: string = 'edit';
  fp: functionpermission;
  initialPage: PageSettingsModel;
  public filterSettings: object;
  filter: IFilter;
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  TotalCount: number;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public isinitialLoad: boolean = false;
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  valuechange: any = []
  ListSendBO: GetListBO = new GetListBO();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  error: any = "";
  showErrorAlert: boolean = false;
  constructor(public http: HttpClient, private formBuilder: FormBuilder, public global: GlobalComponent,public CommonAPI: CommonApiService, public toastrService: ToastrService, public General: GeneralService,) {
    this.global.agencyList();
    this.data = CommonAPI;
    this.DischargeForm = this.formBuilder.group({
      DischargeCode: ['', Validators.required],
      Codedescription: ['', Validators.required]
    });
  }
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "DischargeCode";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Dccodes.Pagesize != state.take) {
          this.arraycol[0].Dccodes.Pagesize = state.take
       }
      }
    }
    this.getDischarge();
  }
  ngOnInit() {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0||this.global.globalAgencyId=='00000000-0000-0000-0000-000000000000') {
      return;
    }
    if (this.changevalue == 'client') {
      this.viewClient = true;
    }
    this.conditionlist.push(new WhereCondition());
    this.SearchColumn.key = 'DisChargeCode';
    this.SearchColumn.value = 'DisChargeCode';
    this.toolbar = ['ColumnChooser'];
    this.fp = new functionpermission();
    this.filepermissionget();
    this.filterSettings = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getDischarge();
  }
  //...................................onActionComplete................................................................
  public onActionComplete(args) {
    this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].Dccodes.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].Dccodes.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].Dccodes.ShowColumns.length != count1 || this.arraycol[0].Dccodes.HideColumns.length != count) {
          this.arraycol[0].Dccodes.ShowColumns = showarr;
          this.arraycol[0].Dccodes.HideColumns = hidearr;
        }
      }
    }
  }
  change(args: ChangeEventArgs) {
    this.initialPage = { currentPage: args.value };
  }
  actionHandler(args) {
    if (args.requestType == "sorting") {

    }
    else if (args.requestType == "filtering") {
    }
  }
  deleteDischarge() {
    let url = "api/DischargeCodeDetail/DeleteDischargeCodeDetail?";
    let params = new URLSearchParams();
    params.append("DischargeId", this.dccodes.id.toString());
    this.http.delete(url + params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      this.toastrService.success(
        "Discharge code deleted successfully!"), 8000
      document.getElementById('openModal2').click()
      this.getDischarge();
      // this.getTotalCount();
    },
    (err: HttpErrorResponse) => {
      this.toastrService.error(err.error, "Error"), 8000;
    }
    )
  }
  selectDischargedetails(ddetails: DischargeCodeDetailBO) {
    this.dccodes = ddetails;
    this.valueschanges()
    this.dccodes = JSON.parse(JSON.stringify(ddetails));
  }
  paginationChange(event) {
    this.pagshort.currentPgNo = event;
    this.getDischarge();

  }
  valueschanges() {
    this.valuechange = {
      DischargeCode: 0,
      CodeDescription: 0
    }
  }
  checkpopup(value) {
    if (value == "DischargeCode") {
      this.valuechange.DischargeCode++;
    }
    if (value == "CodeDiscrption") {
      this.valuechange.CodeDescription++;
    }
  }
  openDialog() {
    if (this.valuechange.DischargeCode > 1 || this.valuechange.CodeDescription > 1) {
      document.getElementById('cancelmodal').click();
    }
    else {
      document.getElementById('openModal1').click();
    }
  }
  closeAddUpdateModal() {
    document.getElementById('openModal1').click();
    document.getElementById('cancelmodal').click();
  }
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  Refresh() {
    this.SearchText = "";
    this.ListSendBO.field = "DischargeCode"
    this.ListSendBO.value = ''
    this.pagshort = new sortingObj();
    this.getDischarge();
    // this.getTotalCount();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  getStatus() {
    let url = "api/DischargeCodeDetail/GetDischargeCodeListFilter";
    this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.DischargeArray = data;
    }, (err: HttpErrorResponse) => {

    })
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.Search();
    }
  }
  setDefaultValue() {
    this.SearchText = "";
    if (this.SearchColumn == undefined)
      this.SearchColumn = {
        'DischargeCode': 'Code'
      };
  }
  filteselect(value) {
    this.SearchColumn = value;
    this.getDischarge();
  }
  pageItemsChage(pageitems) {
    this.pagshort.itemperpage = pageitems;
    this.getDischarge();
    // this.getTotalCount();
  }
  DischargeCreateUpdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.DischargeForm.reset();
      this.dccodes = new DischargeCodeDetailBO();
    }
    else {
      this.ModelType = 'edit';

    }
    this.valueschanges()
  }
  // //////////////////////////////////////////////////////////
  SaveOrUpdateDischarge() {
    let url = "api/DischargeCodeDetail/SaveDischargeCodeDetail";
    var saveList: DischargeCodeDetailBO = JSON.parse(JSON.stringify(this.dccodes));
    saveList.dischargeCode = this.General.reconverPhoneGoogleLib(saveList.dischargeCode);
    saveList.codeDescription = this.General.reconverPhoneGoogleLib(saveList.codeDescription);
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      document.getElementById('openModal1').click();
      if (data) {
        if (this.ModelType == 'new') {
          this.toastrService.success(
            "Discharge code saved successfully!"), 8000
          saveList.id = data;
          document.getElementById('openModal1').click();
          this.getDischarge()
        }
        else if (this.ModelType == 'edit') {
          this.toastrService.success(
            "Discharge code updated successfully!"), 8000
          saveList.id = data;
          document.getElementById('openModal1').click();
          this.getDischarge()
        }
      }
    }, (err: HttpErrorResponse) => {
      if (err) {
        this.error = err.error;
        this.showErrorAlert = true
      }
      else {
        this.error = JSON.stringify(err.error);
      }
      if (this.error != "") {
        setTimeout(() => {
          this.error = "";
          this.showErrorAlert = false
        }, 5000)
      }
    })
  }
  getDischarge() {
    let url = "api/DischargeCodeDetail/GetDischargeCodeListFilter?"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.CommonAPI.outputValues(url, this.ListSendBO, responseData,"");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.DischargeDataList = data.result;
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
        if (this.global.globalAgencyId != "00000000-0000-0000-0000-000000000000") {
        }
      }
    })
  }
  Search() {
    this.ListSendBO.field = this.SearchColumn.key
    this.ListSendBO.value = this.SearchText;
    this.pagshort.currentPgNo = 1;
    // this.getTotalCount();
    this.getDischarge();
  }
  // getTotalCount() {
  //   let params = new URLSearchParams();
  //   params.append("SearchColumn", this.SearchColumn.key);
  //   params.append("SearchText", this.SearchText);
  //   let url = "api/DischargeCodeDetail/GetDischargeCodeList_Count?";
  //   this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
  //     this.TotalCount = data;
  //   });
  // }
 
  filepermissionget() {
    let params = new URLSearchParams();
    params.append("pagecode", "DischargeCode");
   // params.append("agencyId", this.global.agencyId);
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    this.http.get(url+params).pipe(takeUntil(this.onDestroy$)).subscribe((data: functionpermission) => {
      this.fp = data;
    });
  }
  selectDC(data) {
    this.dataFromDC.emit({ code: data.id, description: data.codeDescription })
  }
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString()
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.grid.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
    }
  }
    
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
